const FALLBACK_IMAGE = "https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/camera-512.png";

/**
 * Returns the correct image URL for a product.
 * - Local images (image1) served from backend directly.
 * - Merchant images proxied through backend to avoid mixed content (HTTP/HTTPS) issues.
 */
const getProductImageUrl = (product) => {
  const localImage = product?.image1 || product?.image;
  if (localImage) return process.env.REACT_APP_URL + localImage;
  if (product?.merchant_image) return `${process.env.REACT_APP_URL}api/proxy/image?url=${encodeURIComponent(product.merchant_image)}`;
  return FALLBACK_IMAGE;
};

export { getProductImageUrl, FALLBACK_IMAGE };
